import 'requestidlecallback-polyfill';
import '@models/next/setup';

import React from 'react';

import { createRoot } from 'react-dom/client';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './index.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

console.info(`Branch: ${GIT_BRANCH}, VITE_APP_STAGE=${process.env.VITE_APP_STAGE}`);
console.info(`Commit: https://github.com/MonoidDev/d2d-frontend/commit/${GIT_HASH}`);

const meta = document.createElement('meta');
meta.name = 'stage';
meta.content = import.meta.env.VITE_APP_STAGE;
document.head.appendChild(meta);
